import MyProfile from "./Sections/MyProfile";
import ChangePassword from "./Sections/ChangePassword";

const tabsConfig = [
    { id: 1, name: "My Profile", component: MyProfile },
    { id: 2, name: "Change Password", component: ChangePassword },
  ];


export { tabsConfig}